import { render, staticRenderFns } from "./AutomaticCourseRegistration.html?vue&type=template&id=86590a84&scoped=true&"
import script from "./AutomaticCourseRegistration.vue?vue&type=script&lang=js&"
export * from "./AutomaticCourseRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticCourseRegistration.scss?vue&type=style&index=0&id=86590a84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86590a84",
  null
  
)

export default component.exports